import { useEffect, useMemo, useRef } from "react";
import { usePageAwarenessState } from "../contexts/PageAwarenessContext";

function safeSignature(value) {
  try {
    return JSON.stringify(value ?? {});
  } catch (_err) {
    return "__unserializable__";
  }
}

export default function usePageAwareness(value) {
  const { registerPageAwareness, clearPageAwareness } = usePageAwarenessState();
  const lastSignatureRef = useRef("");
  const hasRegisteredRef = useRef(false);
  const signature = useMemo(() => safeSignature(value), [value]);

  useEffect(() => {
    if (typeof registerPageAwareness === "function") {
      if (lastSignatureRef.current === signature) return;
      lastSignatureRef.current = signature;
      hasRegisteredRef.current = true;
      registerPageAwareness(value || {});
    }
  }, [registerPageAwareness, signature, value]);

  useEffect(() => {
    return () => {
      if (hasRegisteredRef.current && typeof clearPageAwareness === "function") {
        clearPageAwareness();
      }
    };
  }, [clearPageAwareness]);
}
